// extracted by css-extract-rspack-plugin
export default {"cls1":"Rating-cls1_62g","cls2":"Rating-cls2_dJf Rating-cls1_62g"};